import ContentPage, { Section } from "./ContentPage";
import { PRIVACY } from "../data/legal";

export default function Privacy() {
  return (
    <ContentPage title={PRIVACY.title} updated={PRIVACY.updated}>
      {PRIVACY.sections.map((section) => (
        <Section
          key={section.heading}
          heading={section.heading}
          body={section.body}
          items={section.items}
        />
      ))}
    </ContentPage>
  );
}
